<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xUKo6D/tc-custom/9780226422817.jpg?1729185276543" alt="This image is the cover for the book Decolonizing the Map"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Decolonizing the Map
      </h1>
      <p class="bookDescription body article font2">
        <p>Almost universally, newly independent states seek to affirm their independence and identity by making the production of new maps and atlases a top priority. For formerly colonized peoples, however, this process neither begins nor ends with independence, and it is rarely straightforward. Mapping their own land is fraught with a fresh set of issues: how to define and administer their territories, develop their national identity, establish their role in the community of nations, and more. The contributors to <i>Decolonizing the Map</i> explore this complicated relationship between mapping and decolonization while engaging with recent theoretical debates about the nature of decolonization itself.<br/>  <br/> These essays, originally delivered as the 2010 Kenneth Nebenzahl, Jr., Lectures in the History of Cartography at the Newberry Library, encompass more than two centuries and three continents—Latin America, Africa, and Asia. Ranging from the late eighteenth century through the mid-twentieth, contributors study topics from mapping and national identity in late colonial Mexico to the enduring complications created by the partition of British India and the racialized organization of space in apartheid and post-apartheid South Africa. A vital contribution to studies of both colonization and cartography, <i>Decolonizing the Map</i> is the first book to systematically and comprehensively examine the engagement of mapping in the long—and clearly unfinished—parallel processes of decolonization and nation building in the modern world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James R. Akerman
      </h2>
      
      <p class="authorDescription body article"><B>James R. Akerman</B> is Curator of Maps at the Newberry Library and director of the library’s Hermon Dunlap Smith Center for the History of Cartography. He is editor of <I>Cartographies of Travel and Navigation</I><I>and The Imperial Map</I>, and coeditor of <I>Maps: Finding Our Place in the World</I>, all published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cc665ad